import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';
import { formatDateTime } from '../../../common/utils/helpers';

const { Column } = Table;

@translate()
export default class InterestSettingsHistory extends Component {
  static propTypes = {
    history: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    const { t, history } = this.props;

    return (
      <ResponsiveTable dataSource={history} rowKey={item => item.id} pagination={false}>
        <Column 
          title={t('Dátum zmeny')} 
          render={(text, item) => (
            <span>
              {formatDateTime(item.updatedAt)}
            </span>
          )} 
        />
        <Column
          title={t('Interval')}
          key="action"
          render={(text, item) => (
            <span>
              {item.termMonthsMin} - {item.termMonthsMax} {t('mesiacov')}
            </span>
          )}
        />
        <Column
          title={t('Úroková miera pred zmenou - investor')}
          dataIndex="allocationInterestMax"
          key="allocationInterestMax"
        />
        <Column 
          title={t('Úroková miera pred zmenou - dlžník')} 
          dataIndex="loanInterest" 
          key="loanInterest" 
        />
      </ResponsiveTable>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/setting-management/components/InterestSettingsHistory.js